// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe__wrapper[data-v-1f1fe500]{width:100%;position:relative;overflow:hidden}.iframe__wrapper iframe.absolute[data-v-1f1fe500]{width:100%;height:100%;position:absolute;top:0;left:0}.iframe__wrapper iframe.mocked[data-v-1f1fe500]{background:#000}", ""]);
// Exports
module.exports = exports;
